import { render, staticRenderFns } from "./CragRouteSectionList.vue?vue&type=template&id=1963292e"
import script from "./CragRouteSectionList.vue?vue&type=script&lang=js"
export * from "./CragRouteSectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports